import React from 'react'
import type { FacilitatorLiveSessionCard } from '../../../../../../pure-js/types/FacilitatorLiveSessionMonitor'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { TESTIDS } from '../../../../config/testids'
import { ControlTowerConfirmDialog } from './ControlTowerConfirmDialog'

interface ControlTowerSendTeamDialogProps {
  card: FacilitatorLiveSessionCard | null
  isSending: boolean
  onCancel: () => void
  onConfirm: () => void
}

/** Yes or no before a whole team is sent to the page of its game or debrief, so a stray click moves nobody. */
export const ControlTowerSendTeamDialog: React.FC<ControlTowerSendTeamDialogProps> = ({
  card,
  isSending,
  onCancel,
  onConfirm
}) => {
  const { t } = useTranslation()

  const title = card
    ? t('facilitator.controlTower.sendTeamTitle', 'Send {{team}} to {{activity}}?', {
        team: card.teamName,
        activity: card.activityTitle
      })
    : ''

  const body = t(
    'facilitator.controlTower.sendTeamBody',
    'Everyone in the team is taken there right away, wherever they are in the app.'
  )

  const confirmLabel = isSending
    ? t('facilitator.controlTower.sendTeamSending', 'Sending…')
    : t('facilitator.controlTower.sendTeamConfirm', 'Yes, send')

  return (
    <ControlTowerConfirmDialog
      isOpen={Boolean(card)}
      title={title}
      body={body}
      cancelLabel={t('facilitator.controlTower.sendTeamCancel', 'No')}
      confirmLabel={confirmLabel}
      isConfirming={isSending}
      confirmTestId={TESTIDS.CONTROL_TOWER_SEND_TEAM_CONFIRM_BTN}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  )
}
